import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { resolveMediaUrl } from "@/lib/api";

const AdminLogo = ({ className = "h-11", padded = false }) => {
  const { settings } = useSettings();
  const logo = settings?.logo;
  const name = settings?.site_name || "PT Mandala Cahaya Sentosa";

  if (!logo) {
    return <span className="font-display font-bold text-maroon-800 text-lg">Mandala</span>;
  }

  return (
    <span className={`inline-flex items-center justify-center max-w-full ${padded ? "bg-white rounded-xl px-2 py-1.5" : ""}`}>
      <img
        src={resolveMediaUrl(logo)}
        alt={name}
        className={`${className} w-auto max-w-full object-contain object-left`}
      />
    </span>
  );
};

export default AdminLogo;
